import { useAskInputModeToggleGroupRenderMenu } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAskInputModeToggleGroupRenderMenu.js';
import { useAskInputActions } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputProviderShared.js';
import { getAskModeToggleLabelVisibility } from '#pplx/frontend/apps/ask/composer-sdk-plugins/mode-toggle/getAskModeToggleLabelVisibility.js';
import { useSelectedSearchMode } from '#pplx/frontend/apps/ask/hooks/selected-search-mode-hooks/useSelectedSearchMode.js';
import { ASK_INPUT_MENU } from '#pplx/frontend/apps/ask/types/askInputMenu.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useIsMobileStyle } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { useCallback } from 'react';
/**
 * Shared mode-toggle wiring for the ask-input left attribution (standard +
 * sidecar). Produces the props for `SearchModeToggleLayer`/`AskInputModeToggleGroup`.
 */
export function useAskInputModeToggle({ searchModeControllerProps, searchModeOverride, isFollowUp, showSkills, skillMentionEditorRef, collectionUuid, computerCommandMenuSearchQuery, sideChatAvailable, onSideChatCommandSelect, registerInputKeyDownHandler, onComputerCommandMenuOpenChange, hideCommandItems = false, hideSettingsAction = false, }) {
    const selectedSearchMode = useSelectedSearchMode();
    const isAsiMode = selectedSearchMode === SearchMode.ASI || searchModeOverride === SearchMode.ASI;
    const isMobileStyle = useIsMobileStyle();
    const labelVisibility = getAskModeToggleLabelVisibility(isMobileStyle);
    const canUseComputerCommandMenu = showSkills;
    const computerModeMenuVariant = canUseComputerCommandMenu && isAsiMode ? 'command' : 'none';
    const showComputerModeMenu = computerModeMenuVariant !== 'none';
    const renderMenu = useAskInputModeToggleGroupRenderMenu({
        searchModeControllerProps,
        computerModeMenuVariant,
        skillMentionEditorRef,
        collectionUuid,
        isFollowUp,
        computerCommandMenuSearchQuery,
        sideChatAvailable,
        onSideChatCommandSelect,
        registerInputKeyDownHandler,
        hideCommandItems,
        hideSettingsAction,
    });
    const { onActiveMenuChange, closeActiveMenuIfCurrent } = useAskInputActions();
    const handleToggleComputerCommandMenu = useCallback((open) => {
        if (!canUseComputerCommandMenu)
            return;
        if (open) {
            onActiveMenuChange(ASK_INPUT_MENU.COMPUTER_COMMAND_MENU);
        }
        else {
            closeActiveMenuIfCurrent(ASK_INPUT_MENU.COMPUTER_COMMAND_MENU);
        }
    }, [canUseComputerCommandMenu, closeActiveMenuIfCurrent, onActiveMenuChange]);
    const handleComputerCommandMenuOpenChange = useCallback((open) => {
        if (!canUseComputerCommandMenu)
            return;
        handleToggleComputerCommandMenu(open);
        onComputerCommandMenuOpenChange?.(open);
    }, [canUseComputerCommandMenu, handleToggleComputerCommandMenu, onComputerCommandMenuOpenChange]);
    const handleSearchModeSelect = useCallback((searchMode) => {
        if (!searchModeControllerProps.showSearchMode)
            return;
        searchModeControllerProps.onSearchModeSelect(searchMode);
    }, [searchModeControllerProps]);
    return {
        selectedSearchMode,
        isAsiMode,
        canUseComputerCommandMenu,
        showComputerModeMenu,
        computerModeMenuVariant,
        renderMenu,
        labelVisibility,
        onSearchModeSelect: handleSearchModeSelect,
        onComputerCommandMenuOpenChange: handleComputerCommandMenuOpenChange,
    };
}
//# sourceMappingURL=useAskInputModeToggle.js.map